<h2 class="modal-title">Sesja wygasła.</h2>
<div class="modal-content">
  Zaloguj się.
</div>
<div class="modal-footer">
  <a class="btn btn-outline-primary"
     href="/login?service={{location.path().slice(1,location.path().length)}}">Zaloguj</a>
</div>
